/**
 * Asset Expenses Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const assetExpensesAPI = {
  getAll: (params) => apiClient.get('/asset-expenses', { params }),
  getById: (id) => apiClient.get(`/asset-expenses/${id}`),
  getByAsset: (assetId, params) => apiClient.get(`/asset-expenses/asset/${assetId}`, { params }),
  getSummaryByAsset: (params) => apiClient.get('/asset-expenses/summary/by-asset', { params }),
  getSummaryByCategory: (params) => apiClient.get('/asset-expenses/summary/by-category', { params }),
  create: (data) => apiClient.post('/asset-expenses', data),
  update: (id, data) => apiClient.put(`/asset-expenses/${id}`, data),
  delete: (id) => apiClient.delete(`/asset-expenses/${id}`),
};

export default assetExpensesAPI;

